@for (field of fields; track field.position) { 
   @if(!field.isEmptyField){
    <div [class]="styleField(field.position, field.style)" (click)="showInfoField(field)">
      <div class="info-field d-flex flex-column">
        <div class="block-icons d-flex justify-content-center align-items-center" >
          @for (icon of field.icons; track $index) {
            <div class="block-icons__icon" [style.background-color]="addOpacity(field.sector_color)">
                <span class="material-symbols-outlined" [style.color]="field.sector_color">
                  {{ icon }}
                </span>
            </div>
          }
        </div>
        <!-- <span class="info-field__title">{{ field.title }}</span>
        <div class="line-all"></div>
        <span class="info-field__description">{{ field.comment }}</span>
        <span class="info-field__xp">+20 XP</span> -->
      </div>

    </div>    
   }   

}
